export const makeCustomRounding = (rounding: number) => (target: number) => {
  if (Number.isInteger(target)) {
    return target
  }
  const decimal = parseFloat(`0.${target.toString().split('.')[1]}`)
  return decimal + Number.EPSILON >= rounding ? Math.ceil(target) : Math.floor(target)
}
